import { FunctionComponent, useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { AnnuaireVisitResult, TRACK_ANNUAIRE_VISIT } from '@/modules/API/software/annuaireTracking'
import AnnuaireTrackingDialog from './AnnuaireTrackingDialog'
import { Role } from '@/types/Role.ts'

interface AnnuaireTrackingHandlerProps {
    role: Role
    onConsentAccepted?: () => void
}

const AnnuaireTrackingHandler: FunctionComponent<AnnuaireTrackingHandlerProps> = ({
    role,
    onConsentAccepted
}: AnnuaireTrackingHandlerProps) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)
    const [result, setResult] = useState<AnnuaireVisitResult | null>(null)

    const [trackAnnuaireVisit] = useMutation(TRACK_ANNUAIRE_VISIT, {
        onCompleted: (data: { trackAnnuaireVisit: AnnuaireVisitResult }) => {
            setResult(data.trackAnnuaireVisit)
            setDialogOpen(true)
        }
    })

    useEffect((): void => {
        const annuaireId: string | null = localStorage.getItem('requestDaycare')
        if (!annuaireId) return
        trackAnnuaireVisit({ variables: { annuaireId: parseInt(annuaireId) } })
        localStorage.removeItem('requestDaycare')
    }, [])

    if (!result) return null

    return (
        <AnnuaireTrackingDialog
            open={dialogOpen}
            result={result}
            handleClose={() => setDialogOpen(false)}
            role={role}
            onConsentAccepted={onConsentAccepted}
        />
    )
}

export default AnnuaireTrackingHandler
